import { createFeatureSelector } from '@ngrx/store';
import { ActivatedRouteSnapshot, Params, RouterStateSnapshot } from '@angular/router';
import { RouterReducerState, RouterStateSerializer } from '@ngrx/router-store';
import { Injectable } from '@angular/core';

export const routerFeatureKey = 'router';

export interface RouterStateUrl {
    url: string;
    params: Params;
    queryParams: Params;
}

export const selectRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

@Injectable()
export class RouterCleanSerializer implements RouterStateSerializer<RouterStateUrl> {
    serialize(routerState: RouterStateSnapshot): RouterStateUrl {
        const { url } = routerState;
        const { queryParams } = routerState.root;

        let state: ActivatedRouteSnapshot = routerState.root;

        while (state.firstChild) {
            state = state.firstChild;
        }

        const { params } = state;

        return { url, params, queryParams };
    }
}
